import { createSelector } from '@ngrx/store';

import { getCurrentRoute } from '../getCurrentRoute';

export const isCurrentRouteLocations = createSelector(getCurrentRoute, (current) => current?.url === '/locations' || current?.url === '');
